// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { register } from '../services/api';

// const CreateUser = () => {
//   const [formData, setFormData] = useState({
//     username: '',
//     email: '',
//     password: '',
//     role: 'employee',
//     employee_name: '',
//     employee_code: '',
//   });
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const role = localStorage.getItem('role');

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (role !== 'super_admin') {
//       navigate('/dashboard');
//       return;
//     }
//     try {
//       const response = await register(formData);
//       if (response.data.success) {
//         alert('User created successfully');
//         navigate('/dashboard/users');
//       } else {
//         setError(response.data.error || 'Failed to create user');
//       }
//     } catch (err) {
//       console.error('Error creating user:', err);
//       setError(err.response?.data?.error || 'Failed to create user');
//     }
//   };

//   if (role !== 'super_admin') return null;

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <h2 className="text-3xl font-bold text-gray-900 mb-6">Create User</h2>
//       <div className="bg-white p-8 rounded-xl shadow-md max-w-md mx-auto">
//         {error && <p className="text-red-600 mb-4">{error}</p>}
//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label className="block text-gray-700 font-medium mb-2">Username *</label>
//             <input
//               type="text"
//               name="username"
//               value={formData.username}
//               onChange={handleChange}
//               className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//               required
//             />
//           </div>

//           <div>
//             <label className="block text-gray-700 font-medium mb-2">Email *</label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//               required
//             />
//           </div>

//           <div>
//             <label className="block text-gray-700 font-medium mb-2">Password *</label>
//             <input
//               type="password"
//               name="password"
//               value={formData.password}
//               onChange={handleChange}
//               className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//               required
//             />
//           </div>

//           <div>
//             <label className="block text-gray-700 font-medium mb-2">Role *</label>
//             <select
//               name="role"
//               value={formData.role}
//               onChange={handleChange}
//               className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//             >
//               <option value="employee">Employee</option>
//               <option value="manager">Manager</option>
//               <option value="functional_admin">Functional Admin</option>
//               <option value="super_admin">Super Admin</option>
//             </select>
//           </div>

//           <div>
//             <label className="block text-gray-700 font-medium mb-2">Employee Name *</label>
//             <input
//               type="text"
//               name="employee_name"
//               value={formData.employee_name}
//               onChange={handleChange}
//               className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//               required
//             />
//           </div>

//           <div>
//             <label className="block text-gray-700 font-medium mb-2">Employee Code *</label>
//             <input
//               type="text"
//               name="employee_code"
//               value={formData.employee_code}
//               onChange={handleChange}
//               className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//               required
//             />
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-indigo-500 text-white py-3 rounded-md hover:bg-indigo-600 transition-colors"
//           >
//             Create User
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CreateUser;
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { register } from '../services/api';

const CreateUser = () => {
  const [formData, setFormData] = useState({ username: '', email: '', password: '', role: 'employee', employee_name: '', employee_code: '' });
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const role = localStorage.getItem('role');

  const handleChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value }); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (role !== 'super_admin') { navigate('/dashboard'); return; }
    try {
      const response = await register(formData);
      if (response.data.success) {
        alert('User created successfully');
        navigate('/dashboard/users');
      } else {
        setError(response.data.error || 'Failed to create user');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create user');
    }
  };

  if (role !== 'super_admin') return null;

  return (
    <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">Create User</h2>
      <div className="bg-white p-5 sm:p-8 rounded-xl shadow-md max-w-md mx-auto">
        {error && <p className="text-red-600 mb-4 text-sm">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
          {[
            { label: 'Username', name: 'username', type: 'text' },
            { label: 'Email', name: 'email', type: 'email' },
            { label: 'Password', name: 'password', type: 'password' },
            { label: 'Employee Name', name: 'employee_name', type: 'text' },
            { label: 'Employee Code', name: 'employee_code', type: 'text' },
          ].map(({ label, name, type }) => (
            <div key={name}>
              <label className="block text-gray-700 font-medium mb-1 sm:mb-2 text-sm sm:text-base">{label} *</label>
              <input type={type} name={name} value={formData[name]} onChange={handleChange}
                className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base" required />
            </div>
          ))}
          <div>
            <label className="block text-gray-700 font-medium mb-1 sm:mb-2 text-sm sm:text-base">Role *</label>
            <select name="role" value={formData.role} onChange={handleChange}
              className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base">
              <option value="employee">Employee</option>
              <option value="manager">Manager</option>
              <option value="functional_admin">Functional Admin</option>
              <option value="super_admin">Super Admin</option>
            </select>
          </div>
          <button type="submit" className="w-full bg-indigo-500 text-white py-2.5 sm:py-3 rounded-md hover:bg-indigo-600 transition-colors text-sm sm:text-base font-medium">
            Create User
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateUser;